import { UserProfileModel } from '../../models/user-profile.model';
import { ProfileCheckModel } from '../../models/profile-check.model';
import { EnvironmentSettingsModel } from '../../models/environment-settings.model';
import { LocaleModel } from 'src/app/shared/models/locale.model';
import { UserAppModel } from 'src/app/auth/models/user-app.model';
import { UserRoleModel } from '../../models/user-role.model';

export class AuthStateModel {
    environmentSettings?: EnvironmentSettingsModel;
    loading: boolean;
    requestingCode: boolean;
    profileStatus: 'ready' | 'updating' | 'deleting' | 'verifying';
    loggedIn?: boolean;
    userProfile?: UserProfileModel;
    profileCheck?: ProfileCheckModel;

    userLocale: LocaleModel;
    userApps?: UserAppModel[];
    selectedAppId?: number;
    // available user roles
    userRoles?: UserRoleModel[];
}
